import script from "./ComplaintsDisclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComplaintsDisclaimer.vue?vue&type=script&setup=true&lang=ts"

import "./ComplaintsDisclaimer.vue?vue&type=style&index=0&id=0f9acd70&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9acd70"]])

export default __exports__